import type { ReactElement } from 'react';
import { ShieldExclamationIcon } from '@heroicons/react/24/outline';
import { Alert, EmptyState, PageHeader } from '@csa/ui';
import type { SessionResponse } from '../auth/useSession.js';

/**
 * The landing page. Currently a placeholder: it exists so the authenticated
 * shell has something to render and so the no-entitlements path is reachable
 * and reviewable before the consoles are built.
 */
export function Overview({ session }: { session: SessionResponse }): ReactElement {
  return (
    <div className="flex flex-col gap-6">
      <PageHeader
        title={`Welcome, ${session.user.displayName.split(' ')[0] ?? session.user.displayName}`}
        description="Run approved queries and API calls against connected systems. Everything you do here is recorded."
      />

      {session.isBootstrapAdmin ? (
        <Alert tone="warning" title="Bootstrap administrator access">
          You are signed in through the Entra App Role bootstrap because no administrator has been
          assigned in this tool yet. Assign a real Platform Administrator, which disables this path
          automatically.
        </Alert>
      ) : null}

      <EmptyState
        icon={ShieldExclamationIcon}
        title="Nothing to show yet"
        description="Connected targets, recent jobs and pending approvals will appear here once they are configured."
      />
    </div>
  );
}
